interface FormTextRequire {
  children?: string
  className?: string
}

function FormTextRequire({ children, className = '' }: FormTextRequire) {
  return <div className={`text-states-error  ${className}`}>{children}</div>
}
FormTextRequire.displayName = 'FormTextRequire'
export { FormTextRequire }
export default FormTextRequire
